import { useEffect } from 'react';
import { trackEvent } from '../utils/analytics';

/** Sem elemento visível: só escuta a rolagem da página inteira e dispara
 *  `scroll_50`/`scroll_90` uma vez cada, quando a pessoa passa daquele
 *  percentual da altura total do documento. */
function ScrollDepthTracker() {
  useEffect(() => {
    const disparados = new Set();
    const marcos = [
      { pct: 50, evento: 'scroll_50' },
      { pct: 90, evento: 'scroll_90' },
    ];

    const aoRolar = () => {
      const alturaTotal = document.documentElement.scrollHeight - window.innerHeight;
      if (alturaTotal <= 0) return;
      const percentualRolado = (window.scrollY / alturaTotal) * 100;

      marcos.forEach(({ pct, evento }) => {
        if (percentualRolado >= pct && !disparados.has(evento)) {
          disparados.add(evento);
          trackEvent(evento);
        }
      });
    };

    window.addEventListener('scroll', aoRolar, { passive: true });
    return () => window.removeEventListener('scroll', aoRolar);
  }, []);

  return null;
}

export default ScrollDepthTracker;
